/* eslint-disable react/prop-types */
import React from 'react';
import { Document, Page, Text, View, StyleSheet, Font,Image } from '@react-pdf/renderer';

import HeaderPDF from './HeaderPDF';
// Register fonts (optional)
// Font.register({
//   family: 'Roboto',
//   src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf'
// });

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 20,
    color: '#2c3e50',
  },
  section: {
    marginBottom: 15,
    padding: 10,
    backgroundColor: '#f8f9fa',
    borderRadius: 5,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#34495e',
    borderBottom: '1px solid #bdc3c7',
    paddingBottom: 5,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  column: {
    flex: 1,
    marginRight: 10,
  },
  label: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#7f8c8d',
    marginBottom: 2,
  },
  value: {
    fontSize: 10,
    color: '#2c3e50',
    marginBottom: 8,
  },
  checkboxContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 5,
  },
  checkboxItem: {
    flexDirection: 'row',
    marginRight: 15,
    marginBottom: 3,
    alignItems: 'center',
  },
  checkbox: {
    width: 8,
    height: 8,
    border: '1px solid #34495e',
    marginRight: 5,
    backgroundColor: '#ffffff',
  },
  checkedBox: {
    width: 8,
    height: 8,
    border: '1px solid #34495e',
    marginRight: 5,
    backgroundColor: '#27ae60',
  },
  checkboxText: {
    fontSize: 9,
    color: '#2c3e50',
  },
  signatureSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  signatureBox: {
    width: '45%',
    padding: 10,
    border: '1px solid #bdc3c7',
    borderRadius: 5,
  },
  signatureTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center',
    color: '#34495e',
  },
  footer: {
    marginTop: 20,
    padding: 10,
    borderTop: '1px solid #bdc3c7',
    fontSize: 8,
    color: '#7f8c8d',
    textAlign: 'center',
  },
 
 
});

const ExportPDFJobOffer = ({ user, data , agencyInfo }) => {
  // Helper function to format array values
  const formatArrayValue = (array) => {
    if (!Array.isArray(array) || array.length === 0) return 'None selected';
    return array.join(', ');
  };



  // Helper function to render checkbox items
  const renderCheckboxItems = (items, selectedItems) => {
    return items.map((item, index) => (
      <View key={index} style={styles.checkboxItem}>
        <View style={selectedItems.includes(item) ? styles.checkedBox : styles.checkbox} />
        <Text style={styles.checkboxText}>{item}</Text>
      </View>
    ));
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        
        {/* Header */}
         <HeaderPDF user={user} agencyInfo={agencyInfo} />
        <Text style={styles.title}>Job Offer / Offer of Employment (FDW)</Text>
        
        {/* Agency/Employer Section */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Agency / Employer</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Agency:</Text>
              <Text style={styles.value}>{data.agency || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Agency Address:</Text>
              <Text style={styles.value}>{data.agencyAddress || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Agency Phone:</Text>
              <Text style={styles.value}>{data.agencyPhone || 'Not specified'}</Text>
            </View>
          </View>
        </View>

        {/* FDW Section */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Offer made to (FDW)</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Name of FDW:</Text>
              <Text style={styles.value}>{data.fdwName || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Care Recipient Name / NRIC:</Text>
              <Text style={styles.value}>{data.careRecipient || 'Not specified'}</Text>
            </View>
          </View>
        </View>

        {/* Employer's Family Profile */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Employer&apos;s Family Profile</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Employer&apos;s Name:</Text>
              <Text style={styles.value}>{data.employerName || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Nationality:</Text>
              <Text style={styles.value}>{data.employerNationality || 'Not specified'}</Text>
            </View>
          </View>
          
          <Text style={styles.label}>Total members residing in the household:</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Adults:</Text>
              <Text style={styles.value}>{data.numAdults || '0'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Children:</Text>
              <Text style={styles.value}>{data.numChildren || '0'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Infants:</Text>
              <Text style={styles.value}>{data.numInfants || '0'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Elderly:</Text>
              <Text style={styles.value}>{data.numElderly || '0'}</Text>
            </View>
          </View>

          <Text style={styles.label}>Health / Mobility:</Text>
          <View style={styles.checkboxContainer}>
            {renderCheckboxItems(
              ['Mobile', 'Immobile', 'Special Needs', 'Dementia', 'Stroke', 'Bedridden', 'Wheelchair Bound', 'Others'],
              data.health || []
            )}
          </View>
          {data.healthOthers && (
            <View>
              <Text style={styles.label}>Other Health Conditions:</Text>
              <Text style={styles.value}>{data.healthOthers}</Text>
            </View>
          )}
        </View>

        {/* Type of Dwelling */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Type of Dwelling – FDW&apos;s place of work</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Dwelling Type:</Text>
              <Text style={styles.value}>{data.dwelling || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Levels:</Text>
              <Text style={styles.value}>{data.levels || '1'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Bedrooms:</Text>
              <Text style={styles.value}>{data.bedrooms || '1'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Toilets:</Text>
              <Text style={styles.value}>{data.toilets || '1'}</Text>
            </View>
          </View>
        </View>

        {/* Duties */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Duties of the Domestic Worker</Text>
          <View style={styles.checkboxContainer}>
            {renderCheckboxItems(
              [
                'General housekeeping', 'Infant care', 'Toddler care', 'Childcare', 
                'Marketing', 'Cooking', 'Laundry (Handwash)', 'Laundry (Machine)', 
                'Carwash', 'Gardening', 'Pet care'
              ],
              data.duties || []
            )}
          </View>
          
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>No. of cars:</Text>
              <Text style={styles.value}>{data.numCars || '0'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Car details:</Text>
              <Text style={styles.value}>{data.carDetails || 'Not specified'}</Text>
            </View>
          </View>

          {data.specialRequirements && (
            <View>
              <Text style={styles.label}>Special Requirements / Additional duties:</Text>
              <Text style={styles.value}>{data.specialRequirements}</Text>
            </View>
          )}

          {data.nightFeedingFreq && (
            <View>
              <Text style={styles.label}>Night feeding frequency:</Text>
              <Text style={styles.value}>{data.nightFeedingFreq}</Text>
            </View>
          )}
        </View>

        {/* Employment Terms */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Essential Terms of Employment</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Basic Salary (S$):</Text>
              <Text style={styles.value}>{data.basicSalary || '600.00'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Rest days per month:</Text>
              <Text style={styles.value}>{data.restDays || '3'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Compensation in lieu (S$):</Text>
              <Text style={styles.value}>{data.compensInLieu || '69.00'}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Rest Arrangement:</Text>
              <Text style={styles.value}>{data.restArrangement || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Rest hours:</Text>
              <Text style={styles.value}>{data.restHours || 'Not specified'}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Rest day (Day/Time):</Text>
              <Text style={styles.value}>{data.restDayTime || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Handphone usage:</Text>
              <Text style={styles.value}>{data.phoneUsage || 'Not specified'}</Text>
            </View>
          </View>

          {data.religiousPractice && (
            <View>
              <Text style={styles.label}>Religious practice:</Text>
              <Text style={styles.value}>{data.religiousPractice}</Text>
            </View>
          )}
        </View>

        {/* Additional Duties */}
        {data.additionalDuties && (
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Additional Duties (Caregiving arrangement)</Text>
            <Text style={styles.value}>{data.additionalDuties}</Text>
          </View>
        )}

        {/* Signatures */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Agreement & Signatures</Text>
          <Text style={[styles.value, { marginBottom: 15, fontSize: 9, fontStyle: 'italic' }]}>
            The Employer and FDW have mutually agreed and accepted the above stipulated duties as terms and conditions 
            of the job offer and both Parties hereby authorise the Agency to perform all necessary transactions with MOM on their behalf.
          </Text>
          
          <View style={styles.signatureSection}>
            <View style={styles.signatureBox}>
              <Text style={styles.signatureTitle}>Employer Signature</Text>
              <Text style={styles.label}>Name:</Text>
              <Text style={styles.value}>{data.employerSignatureName || ''}</Text>
              <Text style={styles.label}>IC No / ID:</Text>
              <Text style={styles.value}>{data.employerIC || ''}</Text>
              <Text style={styles.label}>Date:</Text>
              <Text style={styles.value}>{data.employerDate || ''}</Text>
            </View>

            <View style={styles.signatureBox}>
              <Text style={styles.signatureTitle}>FDW Signature</Text>
              <Text style={styles.label}>Name:</Text>
              <Text style={styles.value}>{data.fdwSignatureName || ''}</Text>
              <Text style={styles.label}>IC No / Passport:</Text>
              <Text style={styles.value}>{data.fdwIC || ''}</Text>
              <Text style={styles.label}>Date:</Text>
              <Text style={styles.value}>{data.fdwDate || ''}</Text>
            </View>
          </View>

          {data.agencySignature && (
            <View style={{ marginTop: 15 }}>
              <Text style={styles.label}>Agency acknowledgement (signature):</Text>
              <Text style={styles.value}>{data.agencySignature}</Text>
            </View>
          )}
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text>Job Offer Generated on {new Date().toLocaleDateString()}</Text>
          {user && (
            <Text>Agency: {user.company.name || 'Not specified'}</Text>
          )}
        </View>

      </Page>
    </Document>
  );
};

export default ExportPDFJobOffer;
